export function initializeVideoPlayer() {
    const video = document.getElementById("customVideo");
    const playBtn = document.getElementById("playBtn");
    const pauseBtn = document.getElementById("pauseBtn");
    const timeDisplay = document.getElementById("videoTime");
    const progressContainer = document.getElementById("videoProgressContainer");
    const progress = document.getElementById("videoProgress");

    if (!video) return;

    let hideTimeout = null;

    // ── Throttle ─────────────────────────────────────────────────────
    function throttle(fn, limit) {
        let lastCall = 0;
        return function (...args) {
            const now = Date.now();
            if (now - lastCall < limit) return;
            lastCall = now;
            fn.apply(this, args);
        };
    }

    // ── Icon helpers ─────────────────────────────────────────────────
    function showIcon(icon) {
        if (!icon) return;
        gsap.killTweensOf(icon);
        gsap.set(icon, { display: "block" });
        gsap.fromTo(icon,
            { opacity: 0, scale: 0.7 },
            { opacity: 1, scale: 1, duration: 0.2, ease: "back.out(1.7)" }
        );
    }

    function fadeOutIcon(icon) {
        if (!icon) return;
        gsap.killTweensOf(icon);
        gsap.to(icon, {
            opacity: 0,
            scale: 0.8,
            duration: 0.4,
            ease: "power2.in",
            onComplete: () => gsap.set(icon, { display: "none", scale: 1 })
        });
    }

    function hideOther(other) {
        gsap.killTweensOf(other);
        gsap.set(other, { display: "none", opacity: 0, scale: 1 });
    }

    // ── Auto hide ────────────────────────────────────────────────────
    function autoHide(delay = 1500) {
        clearTimeout(hideTimeout);
        hideTimeout = setTimeout(() => {
            fadeOutIcon(playBtn);
            fadeOutIcon(pauseBtn);
        }, delay);
    }

    // ── Show play / pause ─────────────────────────────────────────────
    function showPlay() {
        hideOther(pauseBtn);
        showIcon(playBtn);
    }

    function showPause() {
        hideOther(playBtn);
        showIcon(pauseBtn);
    }

    // ── Toggle ────────────────────────────────────────────────────────
    function togglePlay() {
        if (video.paused) {
            video.play();
            showPause();
            autoHide();
        } else {
            video.pause();
            showPlay();
            autoHide(2000);
        }
    }

    // ── Events ────────────────────────────────────────────────────────
    video.addEventListener("click", togglePlay);
    playBtn?.addEventListener("click", togglePlay);
    pauseBtn?.addEventListener("click", togglePlay);

    video.addEventListener("play", () => {
        showPause();
        autoHide();
    });

    video.addEventListener("pause", () => {
        showPlay();
        autoHide(2500);
    });

    video.addEventListener("ended", () => {
        hideOther(pauseBtn);
        showIcon(playBtn);
        clearTimeout(hideTimeout);
    });

    // ── Throttled mousemove ───────────────────────────────────────────
    const handleMouseMove = throttle(() => {
        if (!video.paused) {
            const opacity = gsap.getProperty(pauseBtn, "opacity");
            if (opacity < 1) {
                showPause();
            }
            autoHide();
        }
    }, 300);

    video.addEventListener("mousemove", handleMouseMove);
    video.addEventListener("touchstart", () => {
        if (!video.paused) {
            showPause();
            autoHide();
        }
    });

    // ── Progress & time ───────────────────────────────────────────────
    video.addEventListener("loadedmetadata", () => {
        if (timeDisplay)
            timeDisplay.textContent = `00:00 / ${formatTime(video.duration)}`;
    });

    video.addEventListener("timeupdate", () => {
        if (timeDisplay)
            timeDisplay.textContent = `${formatTime(video.currentTime)} / ${formatTime(video.duration)}`;
        if (progress)
            progress.style.width = (video.currentTime / video.duration) * 100 + "%";
    });

    progressContainer?.addEventListener("click", (e) => {
        if (!video.duration) return;
        const rect = progressContainer.getBoundingClientRect();
        const percent = (e.clientX - rect.left) / rect.width;
        video.currentTime = percent * video.duration;
    });

    // ── Utils ─────────────────────────────────────────────────────────
    function formatTime(t) {
        if (isNaN(t)) return "00:00";
        const m = Math.floor(t / 60).toString().padStart(2, "0");
        const s = Math.floor(t % 60).toString().padStart(2, "0");
        return `${m}:${s}`;
    }

    // ── Initial state ─────────────────────────────────────────────────
    gsap.set(pauseBtn, { display: "none", opacity: 0 });
    gsap.set(playBtn, { display: "block", opacity: 1 });
}